/* eslint-disable no-new */
import 'intersection-observer'; // polyfill for intersectionobserver
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VueApollo from 'vue-apollo';
import ApolloClient from 'apollo-boost';
import VueObserveVisibility from 'vue-observe-visibility';
import VueLazyload from 'vue-lazyload';

import messages from '../lang/index';
import App from '../components/home/App.vue';
import '../styles/home.scss';
import '../styles/components/article_videos.scss';

Vue.use(VueApollo);
Vue.use(VueObserveVisibility);
Vue.use(VueI18n);
Vue.use(VueLazyload, {
  lazyComponent: true
});

Vue.prototype.$isMobile = window.screen.width <= 599;
Vue.prototype.$isDesktop = window.screen.width > 599;

const csrfToken = document.head.querySelector('[name=csrf-token]').content;

const apolloProvider = new VueApollo({
  defaultClient: new ApolloClient({
    uri: '/graphql',
    credentials: 'same-origin',
    headers: {
      'X-CSRF-TOKEN': csrfToken,
    },
  }),
});

document.addEventListener('DOMContentLoaded', () => {
  const allData = document.getElementById('allData').dataset;
  const props = {
    gigsUrl: allData.gigsUrl,
    guidesUrl: allData.guidesUrl,
    reviewsUrl: allData.reviewsUrl,
    articleVideosUrl: allData.articleVideosUrl,
    advert: allData.advert ? JSON.parse(allData.advert) : null,
    heroVideo: allData.heroVideo ? JSON.parse(allData.heroVideo) : null,
    locale: allData.locale,
  };

  const supportedLocales = ['en', 'cn'];
  let locale = props.locale;
  if (!supportedLocales.includes(locale)) {
    locale = 'en';
  }

  const i18n = new VueI18n({
    locale,
    fallbackLocale: 'en',
    messages,
  });

  new Vue({
    el: 'app',
    apolloProvider,
    i18n,
    render: h => h(App, { props }),
  });
});
